module.exports = __webpack_public_path__ + "app/assets/img/business_01.54e96a8c.jpg";